/**
 * Módulo encargado de cerrar y limpiar completamente el modal del grabador.
 * - Detiene todos los streams de audio/video
 * - Elimina elementos del DOM (modal, backdrop, canvases)
 * - Libera recursos de MediaPipe y AudioContext
 */

export function closeModal() {
    try {
        // --- Detener todos los <video> activos en el modal ---
        const videoEls = document.querySelectorAll('#recordPreviewArea video');
        videoEls.forEach(video => {
            try {
                if (video.srcObject) {
                    video.srcObject.getTracks().forEach(track => {
                        if (track.readyState === 'live') track.stop();
                    });
                    video.srcObject = null;
                }
                video.pause();
                video.remove();
            } catch (err) {
                console.warn('[Recorder] Error deteniendo video:', err);
            }
        });

        // --- Detener stream principal (micrófono y cámara) ---
        if (window._activeRecorderStream instanceof MediaStream) {
            try {
                const tracks = window._activeRecorderStream.getTracks();
                tracks.forEach(track => {
                    if (track.readyState === 'live') {
                        track.stop();
                    }
                });
            } catch (err) {
                console.warn('[Recorder] Error deteniendo _activeRecorderStream:', err);
            }
            delete window._activeRecorderStream;
        }

        // --- Detener canvasStream (si existe) ---
        if (window._canvasRecorderStream instanceof MediaStream) {
            try {
                const tracks = window._canvasRecorderStream.getTracks();
                tracks.forEach(track => {
                    if (track.readyState === 'live') {
                        track.stop();
                    }
                });
            } catch (err) {
                console.warn('[Recorder] Error deteniendo _canvasRecorderStream:', err);
            }
            delete window._canvasRecorderStream;
        }

        // --- Detener MediaPipe Camera ---
        if (window._mediaPipeCamera) {
            try {
                if (typeof window._mediaPipeCamera.stop === 'function') {
                    window._mediaPipeCamera.stop();
                }
                const camVideo = window._mediaPipeCamera.video;
                if (camVideo && camVideo.srcObject) {
                    camVideo.srcObject.getTracks().forEach(t => {
                        if (t.readyState === 'live') t.stop();
                    });
                    camVideo.srcObject = null;
                }
                if (camVideo) camVideo.pause();
                if (window._mediaPipeCamera.requestId) {
                    cancelAnimationFrame(window._mediaPipeCamera.requestId);
                }
            } catch (err) {
                console.warn('[Recorder] Error deteniendo _mediaPipeCamera:', err);
            }
            delete window._mediaPipeCamera;
        }

        // --- Cerrar contexto de audio si existiera ---
        if (window._voiceAnalyzer && window._voiceAnalyzer.context) {
            try {
                const ctx = window._voiceAnalyzer.context;
                if (ctx.state !== 'closed') ctx.close();
            } catch (err) {
                console.warn('[Recorder] Error cerrando contexto de audio:', err);
            }
            delete window._voiceAnalyzer;
        }

        // --- Eliminar overlays y canvases ---
        const canvases = document.querySelectorAll('#recordPreviewArea canvas');
        canvases.forEach(c => {
            try {
                c.width = 0;
                c.height = 0;
                c.remove();
            } catch { }
        });

        // --- Eliminar modal y solo el backdrop del grabador ---
        // No tocar otros backdrops (ej. el del wizard o chooser)
        // --- Eliminar modal y solo el backdrop del grabador ---
        const modalEl = document.getElementById('recordPreviewModal');
        const backdropEl = document.querySelector('.modal-backdrop.recorder-backdrop');
        if (modalEl?.parentNode) modalEl.parentNode.removeChild(modalEl);
        if (backdropEl?.parentNode) backdropEl.parentNode.removeChild(backdropEl);

        // --- Restaurar backdrop del wizard ---
        const wizardBackdrop = document.querySelector('.modal-backdrop:not(.recorder-backdrop)');
        if (wizardBackdrop) wizardBackdrop.style.opacity = '';

        // --- Limpiar body solo si no hay otros modales activos ---
        if (!document.querySelector('.modal.show')) {
            document.body.classList.remove('modal-open');
            document.body.style.removeProperty('padding-right');
        }

        // --- Eliminar variables globales ---
        [
            '_activeRecorder',
            '_isRecordingActive',
            '_isRecordingPaused',
            '_recordCountdown'
        ].forEach(v => delete window[v]);

    } catch (e) {
        console.error('[Recorder] Error general al cerrar modal:', e);
    }
}